import { BookingButton } from "./BookingButton";
import { useLanguage } from "../../i18n/LanguageContext";
import { useMemo } from "react";

export const WhyChooseUsSection = ({ isMobile }: { isMobile?: boolean }) => {
  const { t } = useLanguage();

  const benefits = useMemo(
    () => [
      {
        title: t("benefit1_title1"),
        desc: t("benefit1_desc1"),
      },
      {
        title: t("benefit2_title1"),
        desc: t("benefit2_desc1"),
      },
      {
        title: t("benefit3_title1"),
        desc: t("benefit3_desc1"),
      },
      {
        title: t("benefit5_title1"),
        desc: t("benefit5_desc1"),
      },
    ],
    [t]
  );

  return (
    <section className="relative bg-sub-primary pt-14 pb-10 lg:pb-16 lg:pt-24 ">
      <div className="mx-auto max-w-6xl px-4 md:px-6 lg:px-8">
        <div className="grid gap-2 items-start lg:items-center lg:grid-cols-[45%_55%]">
          {/* Cột trái: title + lợi ích */}
          <div className="relative lg:-mr-12 lg:z-10 order-1">
            <p className="text-xl md:text-2xl lg:text-3xl font-semibold text-slate-900 mb-2">
              {t("loiichkhikham")}
              <br />
              <span className="text-primary">{t("khukhamdoingoai")}</span>
            </p>
            <div className="h-1 mt-2 w-[130px] bg-green-600" />

            <div className="mt-8 space-y-5">
              {benefits.map((item, index) => (
                <div
                  key={item.title}
                  className="relative overflow-hidden rounded-tr-2xl rounded-br-2xl bg-white
                         border border-slate-100 px-6 py-5 cursor-default
                         shadow-[0_18px_35px_rgba(15,23,42,0.06)]"
                >
                  <div className="absolute inset-y-0 left-0 w-2 bg-gradient-to-b from-green-500 via-green-400 to-green-300" />

                  <div className="flex items-start gap-4">
                    <div className="mt-1 text-2xl lg:text-3xl font-semibold text-green-600 leading-none">
                      {String(index + 1).padStart(2, "0")}
                    </div>
                    <div>
                      <h3 className="text-base lg:text-lg font-semibold text-slate-900 mb-1">
                        {item.title}
                      </h3>
                      <p className="text-sm md:text-base lg:text-base text-slate-600">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Cột phải: hình ảnh */}
          <div className="relative z-1 w-full order-2 lg:z-0 lg:flex lg:items-center">
            <div className="overflow-hidden shadow-xl bg-slate-200 aspect-[4/3] lg:aspect-square w-full">
              <img
                src="/a16/phong-kham.jpg"
                alt="Không gian khám và điều trị tại Khoa Quốc tế"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      {/* <div className="w-full absolute bottom-0 lg:bottom-10 z-1 flex justify-center">
        <BookingButton isMobile={isMobile}>
          <span>Đặt lịch khám</span>
          <ArrowRight className="w-5 h-5 ml-2 font-bold" />
        </BookingButton>
      </div> */}

      {/* <div className="pointer-events-none absolute h-[200px] w-full left-0 bottom-0">
        <img
          src="/images/logo_108.svg"
          alt=""
          className="absolute -left-10 top-1/3 -translate-y-1/3
                 w-[420px] opacity-10"
        />

        <div className="absolute inset-0 bg-gradient-to-b from-brand-paper/0 via-brand-primary/60 to-brand-primary" />
      </div> */}
    </section>
  );
};
